(() => {
  (() => {
    const dialog = document.getElementById("pb-account-dialog");
    if (!dialog || typeof dialog.showModal !== "function") return;
    const form = dialog.querySelector("[data-pb-account-form]");
    const email = dialog.querySelector("#pb-account-email");
    const error = dialog.querySelector("#pb-account-error");
    let trigger;
    let outsideDown = false;
    const setExpanded = (value) => document.querySelectorAll("[data-pb-account-trigger]").forEach((el) => el.setAttribute("aria-expanded", String(value)));
    document.querySelectorAll("[data-pb-account-trigger]").forEach((el) => {
      el.setAttribute("aria-haspopup", "dialog");
      el.setAttribute("aria-controls", dialog.id);
      el.setAttribute("aria-expanded", "false");
    });
    document.addEventListener("click", (event) => {
      const opener = event.target.closest("[data-pb-account-trigger]");
      if (!opener || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      if (dialog.open) return;
      trigger = opener;
      dialog.showModal();
      document.documentElement.classList.add("pb-account-open");
      setExpanded(true);
      dialog.querySelector("#pb-account-title").focus({ preventScroll: true });
    });
    dialog.querySelector("[data-pb-account-close]").addEventListener("click", () => dialog.close());
    const outside = (event) => {
      const box = dialog.getBoundingClientRect();
      return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
    };
    dialog.addEventListener("pointerdown", (event) => {
      outsideDown = event.target === dialog && outside(event);
    });
    dialog.addEventListener("click", (event) => {
      if (outsideDown && event.target === dialog && outside(event)) dialog.close();
      outsideDown = false;
    });
    dialog.addEventListener("close", () => {
      document.documentElement.classList.remove("pb-account-open");
      setExpanded(false);
      error.hidden = true;
      email.removeAttribute("aria-invalid");
      if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
    });
    email.addEventListener("input", () => {
      error.hidden = true;
      email.removeAttribute("aria-invalid");
    });
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      email.value = email.value.trim();
      if (!email.validity.valid) {
        error.hidden = false;
        email.setAttribute("aria-invalid", "true");
        email.focus();
        return;
      }
      const destination = new URL(form.action, window.location.origin);
      destination.searchParams.set("login_hint", email.value);
      window.location.assign(destination.href);
    });
    window.addEventListener("pageshow", () => {
      if (!dialog.open) document.documentElement.classList.remove("pb-account-open");
      setExpanded(dialog.open);
    });
  })();
})();
